import {Component, inject, Signal} from '@angular/core';
import {ModalService} from '../../services/modal/modal.service';
import {AppModalType} from '../../types/modal/app-modal.type';
import {ModalHostComponent} from './modal-host/modal-host.component';

@Component({
    selector: 'app-modals',
    imports: [
        ModalHostComponent
    ],
    templateUrl: './modals.component.html',
})
export class ModalsComponent {
    protected baseModalZIndex: number;
    protected openModals: Signal<Array<AppModalType>>;
    private readonly modalService = inject(ModalService);

    public constructor() {
        this.openModals = this.modalService.getOpenModalsSignal();
        this.baseModalZIndex = this.getBaseZIndex();
    }

    private getBaseZIndex(): number {
        const rootStyles = window.getComputedStyle(document.documentElement);
        return Number.parseInt(rootStyles.getPropertyValue('--z-index-modals')
            .trim(), 10) || 0;
    }
}
